import $ from 'jquery';
import View from 'mixins/view';
import moment from 'moment/moment';

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($('<div class="hide"></div>'));
        this.editHistory = this.getModel().get('EditHistory');
        this.triggerEl = $(`
            <a class="user-comment__was-edited" href="#">
                Edytowany
            </a>`
        );
        this.triggerEl.on('click', this::this.toggle);
    }
    render() {
        const makeEditHistoryItem = (modifiedAt, textContent) => `
            <div class="edited-version">
                <time datetime="${moment(modifiedAt).format()}">
                    Edytowany: ${moment(modifiedAt).fromNow()}
                </time>
                <p>
                    ${textContent}
                </p>
            </div>
        `;

        this.getRootEl().html(`${
            this.editHistory
                .map((item) => makeEditHistoryItem(item.modifiedAt.date, item.textContent))
                .join('')
        }`);
    }
    getTriggerEl() {
        return this.triggerEl;
    }
    toggle(event) {
        event.preventDefault();
        this.getRootEl().toggleClass('hide');
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/edit-history-view.js